"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ensureColors;

var _get2 = _interopRequireDefault(require("lodash/get"));

var _isValidColor = _interopRequireDefault(require("./isValidColor"));

var _normalizeColor = _interopRequireDefault(require("./normalizeColor"));

var _deriveLightDark = _interopRequireDefault(require("./deriveLightDark"));

var _skipperDefaultPalette = _interopRequireDefault(require("./skipperDefaultPalette"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var defaultPalette = ensureLightMainDark(_skipperDefaultPalette["default"]);

function ensureLightMainDark(palette) {
  if (!palette) throw new Error("palette was ".concat(palette));
  return Object.entries(palette).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1]; // if `value.main` is present, it will tack on the props `light`, `dark`, and `contrastText`


    if (value.main !== undefined) {
      var defaultPaletteMain = (0, _get2["default"])(_skipperDefaultPalette["default"], [key, 'main']);
      var main = (0, _isValidColor["default"])(value.main) ? (0, _normalizeColor["default"])(value.main) : (0, _isValidColor["default"])(defaultPaletteMain) ? (0, _normalizeColor["default"])(defaultPaletteMain) : _skipperDefaultPalette["default"].defaultAccentColor.main;
      var derivedLightDark = (0, _deriveLightDark["default"])(main);
      return {
        key: key,
        value: {
          light: (0, _isValidColor["default"])(value.light) ? (0, _normalizeColor["default"])(value.light) : derivedLightDark.light,
          main: main,
          dark: (0, _isValidColor["default"])(value.dark) ? (0, _normalizeColor["default"])(value.dark) : derivedLightDark.dark,
          contrastText: (0, _isValidColor["default"])(value.contrastText) ? (0, _normalizeColor["default"])(value.contrastText) : derivedLightDark.contrastText
        }
      };
    }

    return {
      key: key,
      value: value
    };
  }).reduce(function (palette, _ref3) {
    var key = _ref3.key,
        value = _ref3.value;
    palette[key] = value;
    return palette;
  }, {});
}

function ensureRequiredPaletteKeys(palette) {
  return _objectSpread(_objectSpread({}, palette), {}, {
    primary: palette.primary || defaultPalette.primary,
    secondary: palette.secondary || defaultPalette.secondary,
    matched: palette.matched || defaultPalette.matched,
    originalPrimary: palette.originalPrimary || palette.primary || defaultPalette.primary,
    originalSecondary: palette.originalSecondary || palette.secondary || defaultPalette.secondary,
    defaultAccentColor: palette.defaultAccentColor || defaultPalette.defaultAccentColor
  });
}

function ensureColors() {
  var palette = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var ensuredColors = ensureLightMainDark(palette);
  return ensureRequiredPaletteKeys(ensuredColors);
}